export const groupsQuery = {
  type: 'getList',
  resource: 'groups',
  payload: {
    pagination: { page: 1, perPage: 500000000 },
    sort: {},
    filter: {},
  },
};
